module.exports = __webpack_public_path__ + "static/media/image4.314d0487.jpeg";